import { render, staticRenderFns } from "./OrderAmount.vue?vue&type=template&id=f2648ea2&scoped=true"
import script from "./OrderAmount.vue?vue&type=script&lang=js"
export * from "./OrderAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2648ea2",
  null
  
)

export default component.exports